import { checkUserHasRequiredPrivilege } from "@/helpers/utils";

// Export a directive object for Vue 3
export const permissionsDirective = {
  beforeMount(el, binding) {
    const permissions = binding.value || [];
    const hasAnyPermission = permissions.length
        ? checkUserHasRequiredPrivilege(permissions)
        : true;

    if (!hasAnyPermission) {
      el.disabled = true;
      // Optional: Add disabled class if needed for non-Bootstrap buttons
      el.classList.add('disabled');
    }
  },
  updated(el, binding) {
    const permissions = binding.value || [];
    const hasAnyPermission = permissions.length
        ? checkUserHasRequiredPrivilege(permissions)
        : true;

    el.disabled = !hasAnyPermission;
    if (!hasAnyPermission) {
      el.classList.add('disabled');
    } else {
      el.classList.remove('disabled');
    }
  }
};